module.exports = __webpack_public_path__ + "static/watertaxi@oceanbeach_fi.26193d4b.jpg";